import React from 'react';
import MobileSidebar from '../Sidebar/MobileSidebar';
import DrawerSwipeBtn from '@/components/uiKit/Drawer/DrawerSwipeBtn';
import { useViewportWidth } from '@/hooks/shared';
import { BaseDrawer } from '@/modules';

export const Footer = () => {
  const { isMobile } = useViewportWidth();

  return (
    <footer className="flex lg:hidden">
      <BaseDrawer content={<MobileSidebar />} direction={isMobile ? 'bottom' : 'left'}>
        <DrawerSwipeBtn variant="bottom" />
      </BaseDrawer>
    </footer>
  );
};
